import milesFilter from '@/library/filters/milesFilter';

export default function(x) {

	if( typeof x === 'number' )
		return `$ ${ milesFilter(x) }`;
	else if( typeof x === 'string' ){
		if( !/\D/g.exec( x ) )
			return `$ ${ milesFilter(parseInt(x)) }`;
	}else
		return '$ -';
};